export default __webpack_public_path__ + "media/elmnt-2.0e97858e.svg";